import React from 'react';
import { motion } from 'framer-motion';

/**
 * 随机生成按钮组件
 * 用户点击后触发动物生成
 * 
 * @param {Object} props
 * @param {Function} props.onGenerate - 点击按钮触发的回调函数
 * @param {boolean} props.isLoading - 是否显示加载状态
 * @param {string} props.text - 按钮显示的文本
 */
const GenerateButton = ({ onGenerate, isLoading, text = "生成随机动物" }) => {
  return (
    <motion.div 
      className="text-center my-0"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ 
        delay: 0.2,
        duration: 0.5 
      }}
    >
      <motion.button
        className="btn-primary flex items-center justify-center mx-auto"
        onClick={onGenerate}
        disabled={isLoading}
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
      >
        {isLoading ? (
          <>
            <svg className="animate-spin -ml-1 mr-2 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            正在生成...
          </>
        ) : (
          <>
            <span className="text-xl mr-2" aria-hidden="true">🐾</span>
            {text}
          </>
        )}
      </motion.button>
      
      <motion.p
        className="text-gray-500 text-sm mt-2"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.5 }}
      >
        点击按钮，探索自然界的奇妙生物！
      </motion.p>
    </motion.div>
  );
};

export default GenerateButton; 